class Blob {
  constructor(element) {
    this.element = element;
    this.rect = element.getBoundingClientRect();
    this.mouseX = -1;
    this.mouseY = -1;
    this.time = 0;
    this.init();
  }

  init() {
    if (window.innerWidth > 600) {
      document.addEventListener("mousemove", this.handleMouseMove.bind(this));
      this.element.addEventListener("mouseover", this.handleMouseOver.bind(this));
      this.element.addEventListener("mouseout", this.handleMouseOut.bind(this));
    } else {
      this.animateBlob();
    }
  }

  animateBlob() {
    const oscillationSpeed = 0.005;
    const oscillationRange = 10;

    const offsetX = oscillationRange * Math.sin(this.time);
    const offsetY = oscillationRange * Math.cos(this.time);

    this.element.style.transform = `translate(${offsetX}px, ${offsetY}px)`;

    this.time += oscillationSpeed;
    requestAnimationFrame(this.animateBlob.bind(this));
  }
}

const blobs = document.querySelectorAll(".blob");
blobs.forEach((blob) => new Blob(blob));




const leftArrow = document.querySelector(".arrow-left");
const rightArrow = document.querySelector(".arrow-right");
const slides = document.querySelectorAll(".slide");

let currentSlide = 0;
let slideInterval;

function showNextSlide() {
  slides[currentSlide].classList.remove("active");
  currentSlide++;
  if (currentSlide >= slides.length) {
    currentSlide = 0;
  }
  slides[currentSlide].classList.add("active");
}

function showPrevSlide() {
  slides[currentSlide].classList.remove("active");
  currentSlide--;
  if (currentSlide < 0) {
    currentSlide = slides.length - 1;
  }
  slides[currentSlide].classList.add("active");
}

function startSlideInterval() {
  clearInterval(slideInterval);
  slideInterval = setInterval(showNextSlide, 5500);
}

leftArrow.addEventListener("click", () => {
  showPrevSlide();
  startSlideInterval();
});

rightArrow.addEventListener("click", () => {
  showNextSlide();
  startSlideInterval();
});

function handleTouchStart(e) {
  const touch = e.touches[0];
  touchStartX = touch.clientX;
}

function handleTouchMove(e) {
  const touch = e.touches[0];
  touchEndX = touch.clientX;
}

function handleTouchEnd() {
  if (touchEndX - touchStartX > 50) {
    showPrevSlide();
    startSlideInterval();
  } else if (touchStartX - touchEndX > 50) {
    showNextSlide();
    startSlideInterval();
  }
}

let touchStartX;
let touchEndX;

document.addEventListener("touchstart", handleTouchStart, false);
document.addEventListener("touchmove", handleTouchMove, false);
document.addEventListener("touchend", handleTouchEnd, false);

startSlideInterval();

window.addEventListener('DOMContentLoaded', (event) => {
    // check viewport size
    if(window.innerWidth <= 768) { // adjust this value according to your needs
        // if viewport size is less than or equal to 768px, load the images
        const imgElements = document.querySelectorAll('.your-image-class');
        imgElements.forEach(img => {
            img.src = img.dataset.src;
        });
    }
});
